import { isRegistered, isStudent } from '../utils';

export const buildToolboxProps = (block, state, authState) => {

  if (!isRegistered(state) || isStudent(state)) {
    return null;
  }

  const props = block?.props ?? {};

  return {
    id: block?.id,
    type: block?.type,
    props: {
      title: props.title ?? null,
      description: props.description ?? null,
      materials: props.materials ?? [],
    },
  };
};

